import { createAppTheme } from 'src/PlatformPortal/theme';

export { createAppTheme };

const theme = createAppTheme(null);

export default theme;
